import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Redirect, withRouter, Link } from "react-router-dom";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { loginFormValidationSchema, initialValues } from "./FormValidations";
import { TextInput, PasswordInput } from "../../components/Input";
import { CustomButton } from "../../components/CustomButton";
import { APP_ROUTES, getParamsAttachedRoute } from "../../helpers/routeHelpers";
import { login } from "../../store/actions";
import AuthWrapper from "./AuthWrapper";
import PageTitles from "../../constants/PageTitles";
import { ERROR, SUCCESS, showToast } from "../../utils/toastUtils";
import { LABLES, NAMES, PLACEHOLDERS } from "./AuthFieldsNames";
import FormikErrorText from "../../components/FormikErrorText/FormikErrorText";

const Login = ({}) => {
    let { EMAIL, PASSWORD } = LABLES;
    const dispatch = useDispatch();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    let isAuthenticated = useSelector((state) => state.userAuth.isAuthenticated);

    const formik = useFormik({
        // enableReinitialize: true,
        initialValues: initialValues.loginForm,
        validationSchema: loginFormValidationSchema,
        onSubmit: (values) => {
            handleFormSubmit(values);
        }
    });

    const handleFormSubmit = async (values) => {
        const { email, password } = values;
        try {
            setIsLoading(true);
            if (email == "admin@mailinator.com" && password == "click123") {
                history.push(getParamsAttachedRoute(APP_ROUTES.PDF_LISTING));
                showToast(SUCCESS, "Login successfully!");
            } else {
                showToast(ERROR, "Invalid Credentials!");
            }
            // await dispatch(
            //     login({
            //         Email: email,
            //         Password: password
            //     })
            // );
        } catch (err) {
        } finally {
            setIsLoading(false);
        }
    };

    if (isAuthenticated) {
        return <Redirect to={APP_ROUTES.PDF_LISTING} />;
    }

    return (
        <>
            <Helmet>
                <title>{PageTitles.LOGIN}</title>
            </Helmet>
            <AuthWrapper>
                <div className="w-100 mt-4">
                    <div className="w-100 p-2">
                        <p className="custom-text">{"Welcome to DigiPub Web Form"}</p>
                        <p className="custom-sub-text">{"Login to continue"}</p>
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-center p-2">
                        <form className="w-100" onSubmit={formik.handleSubmit}>
                            <div className="mb-1">
                                <TextInput
                                    placeholder={PLACEHOLDERS[EMAIL]}
                                    label={EMAIL}
                                    name={NAMES[EMAIL]}
                                    type={NAMES[EMAIL]}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values[NAMES[EMAIL]]}
                                    labelClass="custom-label"
                                    className="hide-default-icon"
                                    autoFocus
                                />
                                <FormikErrorText
                                    formikInstance={formik}
                                    fieldName={NAMES[EMAIL]}
                                    className="error mt-1"
                                />
                            </div>

                            <div>
                                <PasswordInput
                                    placeholder={PLACEHOLDERS[PASSWORD]}
                                    label={PASSWORD}
                                    name={NAMES[PASSWORD]}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values[NAMES[PASSWORD]]}
                                    labelClass="custom-label"
                                />

                                <FormikErrorText
                                    formikInstance={formik}
                                    fieldName={NAMES[PASSWORD]}
                                    className="error mt-1"
                                />
                            </div>
                            <div className="d-flex align-items-center justify-content-end mt-2">
                                <Link to={APP_ROUTES.FORGET_PASSWORD}>
                                    <p className="custom-auth-right-text">Forget password</p>
                                </Link>
                            </div>

                            <CustomButton
                                loading={isLoading}
                                type="submit"
                                title="LOGIN"
                                className="w-100 mt-4 grad-primary"
                                color="primary"
                            />
                        </form>
                    </div>
                </div>
            </AuthWrapper>
        </>
    );
};

export default withRouter(Login);
